import {
  GET_ACTIONS,
  GET_ACTIONS_FAILURE,
  GET_ACTIONS_SUCCESS,
} from '../actions/reportActions';


const report = (state = {}, action) => {
  switch (action.type) {
    case GET_ACTIONS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_ACTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case GET_ACTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        actions: action.res.uactions,
        error: null,
      };
    default:
      return state;
  }
};

export default report;



// WEBPACK FOOTER //
// ./src/reducers/report.js